import { createSelector } from 'reselect';

import { isMerchantApprovedForTransactions } from './merchant';
import { loadingStates } from './loadingStates';

export const isGenerateCredentialsButtonDisabled = createSelector(
  loadingStates,
  isMerchantApprovedForTransactions,
  (
    { isGeneratingCredentials, isFetchingCredentials }: LoadingStates,
    isMerchantApprovedForTransactions,
  ) => !isMerchantApprovedForTransactions || isGeneratingCredentials || isFetchingCredentials,
);

export const isGenerateCredentialsButtonLoading = createSelector(
  loadingStates,
  ({ isGeneratingCredentials, isFetchingCredentials }: LoadingStates) =>
    isGeneratingCredentials || isFetchingCredentials,
);
